import { gql } from '@apollo/client';

import {
  CART_BILLING_ADDRESS_FRAGMENT,
  CART_SHIPPING_ADDRESS_FRAGMENT,
} from '../Address.queries';

const CUSTOMER_ADDRESS_FRAGMENT = gql`
  fragment CustomerAddressDetails on Magento2_CustomerAddress {
    id
    firstname
    lastname
    street
    city
    company
    vatId
    region {
      regionId
    }
    postcode
    countryCode
    telephone
    __typename
  }
`;

export const CUSTOMER_AND_CART_ADDRESSES = gql`
  ${CUSTOMER_ADDRESS_FRAGMENT}
  ${CART_BILLING_ADDRESS_FRAGMENT}
  ${CART_SHIPPING_ADDRESS_FRAGMENT}

  query CustomerAndCartAddressesQuery {
    magento2 {
      customer {
        nativeId
        addresses {
          ...CustomerAddressDetails
        }
      }
      customerCart {
        id
        billingAddress {
          ...CartBillingAddressDetails
        }
        shippingAddresses {
          ...CartShippingAddressDetails
        }
      }
    }
  }
`;

export const ADD_ADDRESS = gql`
  ${CUSTOMER_ADDRESS_FRAGMENT}

  mutation CreateCustomerAddressMutation(
    $input: Magento2_CustomerAddressInput!
  ) {
    magento2 {
      createCustomerAddress(input: $input) {
        ...CustomerAddressDetails
      }
    }
  }
`;

export const UPDATE_ADDRESS = gql`
  ${CUSTOMER_ADDRESS_FRAGMENT}

  mutation UpdateCustomerAddressMutation(
    $id: Int!
    $input: Magento2_CustomerAddressInput!
  ) {
    magento2 {
      updateCustomerAddress(id: $id, input: $input) {
        ...CustomerAddressDetails
      }
    }
  }
`;
